import { render, staticRenderFns } from "./static.vue?vue&type=template&id=16934aa3"
import script from "./static.vue?vue&type=script&lang=js"
export * from "./static.vue?vue&type=script&lang=js"
import style0 from "./static.vue?vue&type=style&index=0&id=16934aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports